var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Campaign' : 'Add Campaign',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "800px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-width": "186px"
    }
  }, [!_vm.dataForm.id ? _c('el-form-item', {
    key: "copyFromId",
    attrs: {
      "label": "Copy From",
      "prop": "copyFromId"
    }
  }, [_c('Campaign-select-remote-search', {
    attrs: {
      "placeholder": "Select an existing data to copy"
    },
    on: {
      "change-item": _vm.copyFromChange
    },
    model: {
      value: _vm.dataForm.copyFromId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "copyFromId", $$v);
      },
      expression: "dataForm.copyFromId"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    key: "title",
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "title",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.title,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "title", $$v);
      },
      expression: "dataForm.title"
    }
  })], 1), _c('el-form-item', {
    key: "templateId",
    attrs: {
      "label": "Template",
      "prop": "templateId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Select Template",
      "filterable": ""
    },
    model: {
      value: _vm.dataForm.templateId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "templateId", $$v);
      },
      expression: "dataForm.templateId"
    }
  }, _vm._l(_vm.templateList, function (item) {
    return _c('el-option', {
      key: "template-".concat(item.id),
      attrs: {
        "label": item.title,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    key: "tagIds",
    attrs: {
      "label": "Tags",
      "prop": "tagIds"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.tagIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "tagIds", $$v);
      },
      expression: "dataForm.tagIds"
    }
  }, _vm._l(_vm.tagInfoList, function (item) {
    return _c('el-option', {
      key: "tag-".concat(item.id),
      attrs: {
        "label": item.tagName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    key: "sendType",
    attrs: {
      "label": "Send Type",
      "prop": "sendType"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Select Send Type"
    },
    model: {
      value: _vm.dataForm.sendType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "sendType", $$v);
      },
      expression: "dataForm.sendType"
    }
  }, _vm._l(_vm.marketingEmailPushTypeList, function (item) {
    return _c('el-option', {
      key: "sendType-".concat(item.value),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _vm.dataForm.sendType == 2 ? _c('el-form-item', {
    key: "scheduledTime",
    attrs: {
      "label": "Scheduled Send Time",
      "prop": "scheduledTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "wdb100",
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "Scheduled Send Time",
      "picker-options": _vm.scheduledTimePickerOptions,
      "popper-class": "hideNowBtn"
    },
    model: {
      value: _vm.dataForm.scheduledTime,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "scheduledTime", $$v);
      },
      expression: "dataForm.scheduledTime"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    key: "remark",
    attrs: {
      "label": "Remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Remark"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }